!
<template>
  <div>
    <config-main-title> Configurações de Pagamento </config-main-title>

    <div class="row mb-3">
      <div class="col col-12 col-md-6">
        <az-input icon="fas fa-search" v-model="search" />
      </div>
      <div class="col col-12 col-md-3 d-flex flex-column">
        <div class="btn-group mb-1" role="group" aria-label="Basic example">
          <button
            type="button"
            class="btn"
            :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="viewMode = 'A'"
          >
            Ativos
          </button>
          <button
            type="button"
            class="btn"
            :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="viewMode = 'T'"
          >
            Todos
          </button>
        </div>
      </div>
      <div class="col col-12 col-md-3 d-flex flex-column">
        <button
          type="button"
          class="btn btn-outline-success"
          @click="incluir_configuracao_pagamento()"
        >
          Incluir
        </button>
      </div>
    </div>

    <div v-if="lista && lista_filtrada.length > 0">
      <div class="list-group mb-3 az-anime-surgir mb-3">
        <li
          class="list-group-item"
          v-for="(configuracao, id) in lista_filtrada"
          :key="id"
        >
          <div class="d-flex justify-content-between">
            <span class="h5 card-link mb-0 mr-3">
              <a href="#" @click.prevent="editar_configuracao_pagamento(configuracao)">
                {{ configuracao.search }}
              </a>
            </span>
            <span>
              <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'categoria-' + id"
                  v-model="configuracao.fl_ativo"
                  @change="alternar_status(configuracao)"
                />
                <label class="custom-control-label" :for="'categoria-' + id"></label>
              </div>
            </span>
          </div>
        </li>
      </div>
    </div>

    <div v-else>
        <az-empty-state msg="Nenhum Pagamento Configurado..." icon="fa-solid fa-credit-card" />
    </div>

    <div
      class="modal fade"
      id="modalConfiguracaoServicoPagamentos"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="item">
          <div class="modal-header">
            <h5 class="modal-title">
              Configurações dos Pagamentos
              <span
                class="badge badge-secondary ml-2"
                v-if="item.id_configuracao_pagamento"
                >#{{ item.id_configuracao_pagamento }}</span
              >
              <span class="badge badge-secondary ml-2" v-else>Nova</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  label="Título"
                  required
                  placeholder="Título da configuração..."
                  :validate="validate"
                  v-model="item.st_titulo"
                />
              </div>
              <div class="col col-12 col-md-6">
                <AzInput
                  label="Serviço Pagamento"
                  type="select"
                  placeholder="Selecione..."
                  :optionsList="servicos_pagamento"
                  optionsData="name"
                  optionsDisplay="name"
                  :validate="validate"
                  :edicao="!item.id_configuracao_pagamento"
                  v-model="item.js_configs.pagamento"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input
                  label="Unidade"
                  type="select"
                  placeholder="Todas as unidades..."
                  optionsData="id_unidade_operacao"
                  :optionsList="$util.unidades_com_tags(false, true)"
                  v-model="item.id_unidade_operacao"
                />
              </div>
            </div>

            <az-sub-title title="Campos" class="mt-3" />
            <template
              v-if="item.js_configs.pagamento
                && carregar_campos_servico(item.js_configs.pagamento).length > 0 "
            >
              <div
                v-for="(campo, index) in carregar_campos_servico(
                  item.js_configs.pagamento
                )"
                :key="index"
              >
                <az-input
                    v-if="campo == 'idFormaPagamentoRecDiretoProf'"
                    :label="labelCampo(campo)"
                    type="select"
                    placeholder="Selecionar..."
                    optionsData="id_forma_pagamento"
                    service="forma_pagamentos.index"
                    :optionsParm="{ repasse_devol: true }"
                    optionsMode="aql"
                    v-model="item.js_configs[campo]" 
                />
                
                <div v-else-if="campo == 'cadastroRecepcaoEc'">
                    <az-sub-title title="Adicionar de-para de Recepções para EC" class="mt-3">
                        <a href="#" @click.prevent="incluir_recepcao_ec()" class="card-link">
                        Incluir&nbsp;<i class="fa fa-plus" aria-hidden="true"></i>
                        </a>
                    </az-sub-title>
                    <template v-for="(config, idx) in recepcoes_ecs">
                        <div class="form-row" :key="idx" v-if="true">
                            <div class="col col-12 col-md-4">
                                <az-input
                                  sizing="sm"
                                  type="autocomplete"
                                  placeholder="Selecione a recepção..."
                                  optionsMode="aql"
                                  service="recepcaos.index"
                                  optionsData="id_recepcao"
                                  optionsDisplay="search"
                                  :optionsParm="item.id_unidade_operacao ? { ativos: true, id_unidade_operacao: item.id_unidade_operacao, filtros: true } : { ativos: true, filtros: true }"
                                  required
                                  v-model="config.id_recepcao"
                                />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input sizing="sm" type="text" placeholder="Nome do EC" v-model="config.st_nome_ec" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input sizing="sm" type="text" placeholder="Número do EC" v-model="config.st_id_ec" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input sizing="sm" type="text" placeholder="Número Lógico" v-model="config.st_id_logico" />
                            </div>
                            <div class="col col-12 col-md-1">
                              <button
                                class="btn btn-outline-danger btn-sm mb-3"
                                type="button"
                                @click="remove_depara_recepcao(idx)"
                              >
                                <i class="fa fa-minus" aria-hidden="true"></i>
                              </button>
                            </div>
                        </div>
                    </template>
                </div>

                <az-input
                  v-else
                  :label="labelCampo(campo)"
                  v-model="item.js_configs[campo]"
                  :type="
                    campo == 'producao' || campo == 'informaFormaPagamento'
                      ? 'checkbox-group'
                      : ''
                  "
                  sizing="sm"
                  class="mt-1"
                />
              </div>
            </template>

            <!-- De-Para de Recepções para Contself -->
            <div class="mt-3" v-if="item.js_configs.pagamento == 'Contself'">
              <az-sub-title title="De-Para de Recepções -> Id Terminal">
                <!-- <a href="#" @click.prevent="incluir_depara_recepcao()" class="card-link">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Incluir De-Para
                </a> -->
              </az-sub-title>
              <template v-for="(depara, idx) in de_para_recepcoes">
                <div class="form-row" :key="idx" v-if="true">
                  <div class="col col-12 col-md-6">
                    <az-input
                      sizing="sm"
                      type="autocomplete"
                      placeholder="Selecione a recepção..."
                      optionsMode="aql"
                      service="recepcaos.index"
                      optionsData="id_recepcao"
                      optionsDisplay="search"
                      :optionsParm="item.id_unidade_operacao ? { ativos: true, id_unidade_operacao: item.id_unidade_operacao, filtros: true } : { ativos: true, filtros: true }"
                      required
                      v-model="depara.id_recepcao"
                    />
                  </div>
                  <div class="col col-12 col-md-5">
                    <az-input
                      sizing="sm"
                      type="text"
                      placeholder="ID do Terminal"
                      v-model="depara.st_id_terminal"
                    />
                  </div>
                  <div class="col col-12 col-md-1 d-flex align-items-end">
                    <button
                      class="btn btn-outline-danger btn-sm mb-3"
                      type="button"
                      @click="remove_depara_recepcao(idx)"
                    >
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </template>

              <a href="#" @click.prevent="incluir_depara_recepcao()" class="btn btn-outline-primary btn-sm">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </a>
            </div>

            <br /><br /><br />
          </div>
          <div class="modal-footer">
            <az-audit-log-button
              v-if="item.id_configuracao_pagamento"
              model="configuracaoPagamentos"
              :id="item.id_configuracao_pacs"
            />
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
            <az-submit @click="atualizar()">{{ item.id_configuracao_pagamento ? "Atualizar" : "Incluir" }}</az-submit>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import AzAuditLogButton from "../../util/AzAuditLogButton.vue";

export default {
  components: {
    ConfigMainTitle,
    AzInput,
    AzSubmit,
    AzSubTitle,
    AzAuditLogButton,
  },

  data() {
    return {
      lista: [],
      servicos_pagamento: [],
      search: "",
      viewMode: "A",
      item: null,
      validate: false,
      recepcoes_ecs: [],
      unidade_operacao_atual: null,
      de_para_recepcoes: []
    };
  },

  computed: {
    opcoes_depara: function () {
      let opcoes = [
        {
          id: "App\\azure\\local",
          search: "Local",
          service: "locals.index",
          nosync: true,
        },
      ];

      return opcoes;
    },

    lista_filtrada: function () {
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      let match = parts;
      let reg = new RegExp(match, "i");

      return this.lista.filter((item) => {
        return (
          (item.fl_ativo || this.viewMode == "T") &&
          (!this.search || reg.test(JSON.stringify(item)))
        );
      });
    },
  },

  methods: {
    
    incluir_depara() {
      this.item.deparas.push({
        model_type: "",
        model_id: "",
        st_id_externo: "",
        excluido: false,
      });
    },

    incluir_depara_recepcao() {
      this.de_para_recepcoes.push({
        id_recepcao: null,
        st_id_terminal: "",
      });
    },

    remove_depara_recepcao(idx) {
      if (this.recepcoes_ecs.length > idx) {
        this.recepcoes_ecs.splice(idx, 1);
      }
      if (this.de_para_recepcoes.length > idx) {
        this.de_para_recepcoes.splice(idx, 1);
      }
    },

    labelCampo(campo) {
      if (campo == "informaFormaPagamento") return "Informar/Enviar Formas de Pagamento";
      if (campo == "idFormaPagamentoRecDiretoProf")
        return "Forma de Pagamento Recebimento Direto Profissional";
      if (campo == "cadastroRecepcaoEc") return "Cadastrar EC das Recepções";

      return campo;
    },

    infoFiltroModel(model) {
      if (!this.opcoes_depara || !model) return {};

      let opcao = this.opcoes_depara.find((item) => item.id == model);

      return opcao;
    },

    carregar() {
      this.$util.load(this, {
        service: "configuracao_pagamento",
        with: ["configuracao_pagamento_ecs"],
        parms: {
          cadastro: true,
        },
        loadTo: (res) => {
          this.lista = res;
        },
      });
    },

    abrir_modal(item) {
      this.item = item;
      
      // Carregar de-para de recepções se existir
      this.de_para_recepcoes = [];
      if (item.js_configs && item.js_configs.de_para_recepcoes) {
        this.de_para_recepcoes = JSON.parse(JSON.stringify(item.js_configs.de_para_recepcoes));
      }
      if (item.configuracao_pagamento_ecs) {
        this.recepcoes_ecs = JSON.parse(JSON.stringify(item.configuracao_pagamento_ecs));
      }

      this.$util.load(this, {
        service: "pagamento_configuracao",
        loadTo: (res) => {
          this.servicos_pagamento = res;
          $("#modalConfiguracaoServicoPagamentos").modal("show");
        },
      });
    },

    incluir_configuracao_pagamento() {
      let item = null;
      this.$nextTick(() => {
        item = {
          st_titulo: "",
          fl_ativo: true,
          id_unidade_operacao: "",
          js_configs: {
            id_pags_service: "",
          },
        };

        this.abrir_modal(item);
      });
    },

    editar_configuracao_pagamento(configuracao) {
      this.abrir_modal(configuracao);
    },

    alternar_status(configuracao) {
      this.$util.toggle(this, {
        service: "configuracao_pagamento",
        dados: configuracao,
      });
    },

    carregar_campos_servico(nome) {
      const servico = this.servicos_pagamento.find((servico) => servico.name == nome);

      if (servico && servico.js_configs) {
        return servico.js_configs;
      }

      return [];
    },

    atualizar() {
        // Salvar de-para de recepções no js_configs
        if (this.de_para_recepcoes.length > 0) {
            this.$set(this.item.js_configs, 'de_para_recepcoes', this.de_para_recepcoes);
        } else {
            this.$delete(this.item.js_configs, 'de_para_recepcoes');
        }
        
        this.$util.atualizar(this, {
            service: "configuracao_pagamento",
            dados: this.item,
            modal: "modalConfiguracaoServicoPagamentos",
            callback: () => {
                if (this.recepcoes_ecs.length > 0) {
                    let query = {
                        q: [
                            {
                                name: "salvar_recepcao_ec",
                                id: "salvar_recepcao_ec",
                                parms: {
                                    id_configuracao_pagamento: this.item.id_configuracao_pagamento,
                                    recepcoes_ecs: this.recepcoes_ecs
                                },
                            },
                        ],
                    };
                    this.axios.post("/aql", query);
                }
                this.carregar();
            }
        });
    },

    incluir_recepcao_ec() {
        this.recepcoes_ecs.push({
            id_recepcao: null,
            st_nome_ec: "",
            st_id_ec: "",
            st_id_logico: ""
        });
    },
    remove_recepcao_ec(idx) {
        this.recepcoes_ecs.splice(idx, 1);
    },
  },

  mounted() {
    this.carregar();

    this.breadcrumb = [
      { name: "Configurações", path: "/cadastros" },
      { name: "Configurações de Pagamento", path: "" },
    ];

    this.$store.commit("setBreadcrumb", this.breadcrumb);
    if (this.$store && this.$store.state.state) {
        this.unidade_operacao_atual = this.$store.state.unidade_operacao_atual;
    }
    
  },
};
</script>
<style></style>